
import {Component, Vue} from "vue-property-decorator";

import VanImagePreview from 'vant/lib/image-preview';
import 'vant/lib/image-preview/style';
@Component({
    components:{
        // VanImagePreview
    }
})
export default class HomeClass extends Vue {


    public images:any = {
        1:[
            'http://img.nirne.com/newZz/mt-tp.png',
            'http://img.nirne.com/newZz/0.png',
            "http://img.nirne.com/newZz/1.png",
            "http://img.nirne.com/newZz/2.png",
            "http://img.nirne.com/newZz/3.png",
            "http://img.nirne.com/newZz/4.png",
            "http://img.nirne.com/newZz/5.png",
            "http://img.nirne.com/newZz/6.png",
            "http://img.nirne.com/newZz/8.png",
            ""
        ],
        2:[
            "http://img.nirne.com/newRz/2.png",
            "http://img.nirne.com/newRz/3.png",
            "http://img.nirne.com/newRz/1.png",
            ""
        ],
        3:[
            "http://img.nirne.com/newZs/1.png",
            "http://img.nirne.com/newZs/2.png",
            "http://img.nirne.com/newZs/3.png",
            "http://img.nirne.com/newZs/4.png",
            "http://img.nirne.com/newZs/6.png",
            "http://img.nirne.com/newZs/7.png",
            "http://img.nirne.com/newZs/8.png",
            "http://img.nirne.com/newZs/9.png",
            "http://img.nirne.com/newZs/5.png",
            "http://img.nirne.com/newZs/0.png",
            "http://img.nirne.com/newZs/10.png",
            ""
        ],
    }

    public show:any = false;
    public index:any = 0;
    // public images:any = [
    //     'https://img01.yzcdn.cn/vant/apple-1.jpg',
    //     'https://img01.yzcdn.cn/vant/apple-2.jpg',
    // ];
    public active:number=1;


    mounted(){
    }

    public onChange(index:any){
        this.index = index;
    }

    public more() {
        this.$emit('more')
    }

    public tabClcik(size:any){
        console.log(size);
        this.active = '';
        this.active = size;
    }

    public perView(t:any,src:any){
        VanImagePreview({images:[src,...this.images[t].filter((item:any)=>item && item !==src)],closeable:true});
    }

}
